import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import BotaoNovaLinha from '../../components/botao/BotaoNovaLinha'
import Footer from '../../components/footer/Footer'
import ModalEditarLinhaAtendimento from '../../components/modal/ModalEditarLinhaAtendimento';
import { TbPencil } from "react-icons/tb";
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';
import Tabela from '../../components/Tabela';

function LinhaAtendimentoDemanda() {
    const { LinhasConsulta, modalEditarOpen, loading, ListaLinhaAtendimentoConsulta, setModalEditar, setDemandaAtual, Error, ListaPessoa, Success, Permissao, setLinhaAtualKey, ListaFiltroLinhaAtendimento, totalRegistrosLinhaAtendimento, filtroLinhaAtendimento, totalRegistrosFiltroLinhaAtendimento, AtualizarStatus } = useContext(ApiContext)
    const { h3Demanda, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCadastro = (props) => {
        setDemandaAtual(props)
        setLinhaAtualKey(props.key)
        setModalEditar(true)
    }

    const AtualizarAtivo = (x) => {
        AtualizarStatus("LinhaAtendimentoDemanda", x.key, !x.ativo, currentPage)
            .then(() => {
                if (searchTerm.trim() !== "") {
                    ListaFiltroLinhaAtendimento(searchTerm, currentPage, pageSize);
                }
            })
            .catch(() => { })
    }

    useEffect(() => {
        ListaPessoa()
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroLinhaAtendimento(searchTerm, currentPage, pageSize);
        } else {
            ListaLinhaAtendimentoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroLinhaAtendimento : totalRegistrosLinhaAtendimento;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <>
            <Header pagina={'Cadastros'} subpagina={'Times'}></Header>
            <MenuLateral></MenuLateral>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className="container-principal">
                <div className="demanda-header">
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <BotaoNovaLinha currentPage={currentPage} />
                    }
                    {modalEditarOpen &&
                        <ModalEditarLinhaAtendimento end="LinhaAtendimentoDemanda" currentPage={currentPage} />
                    }
                </div>
                <div className="card card-table">
                    <h3 className='h3-demanda' style={h3Demanda}>Times cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroLinhaAtendimento : LinhasConsulta}
                        columns={[
                            { label: "Time", field: "nome", width: "40%" },
                            { label: "Responsável", field: "responsavel", width: "40%", render: (x) => x?.responsavel?.nome || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => AtualizarAtivo(x)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditCadastro(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroLinhaAtendimento(term, 1, 10);
                            } else {
                                ListaLinhaAtendimentoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}

export default LinhaAtendimentoDemanda;